import { render, staticRenderFns } from "./ContenitoriCristal.vue?vue&type=template&id=68af31f9&"
import script from "./ContenitoriCristal.vue?vue&type=script&lang=js&"
export * from "./ContenitoriCristal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports